module.exports = "https://cdn.test.betha.cloud/base/g4/design/4.0.0-alpha3/assets/images/b30-sem-resultado.png";